import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
export class MinimumQuantityQualifier {
    phase = CouponApplyPhase.PreApply;
    _itemCount;
    constructor(itemCount) {
        this._itemCount = itemCount;
    }
    qualify(coupon, _) {
        if (coupon.minimumItemQuantity === undefined)
            return { isValid: true, errorCode: null };
        if (coupon.minimumItemQuantity > this._itemCount)
            return { isValid: false, errorCode: CouponApplyErrorCode.MINIMUM_QUANTITY_NOT_MET };
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=minimum-quantity.js.map